import { FC } from "react";
import { GBtn } from "..";
import { css } from "@emotion/react";

type Props = React.ComponentProps<typeof GBtn>;

const GBtnGradientBorderGlow: FC<Props> = (props) => {
  const styles = css`
    &:before {
      content: "";
      background: linear-gradient(
        45deg,
        #ff0000,
        #ff7300,
        #fffb00,
        #48ff00,
        #00ffd5,
        #002bff,
        #7a00ff,
        #ff00c8,
        #ff0000
      );
      position: absolute;
      top: -2px;
      left: -2px;
      background-size: 400%;
      z-index: -1;
      filter: blur(5px);
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      animation: glowing 20s linear infinite;
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
      border-radius: 10px;
    }

    &:active {
      color: #000;
    }

    &:active:after {
      background: transparent;
    }

    &:hover:before {
      opacity: 1;
    }

    &:after {
      z-index: -1;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background: inherit;
      left: 0;
      top: 0;
      border-radius: 10px;
    }

    @keyframes glowing {
      0% {
        background-position: 0 0;
      }
      50% {
        background-position: 400% 0;
      }
      100% {
        background-position: 0 0;
      }
    }
  `;

  return <GBtn css={styles} {...props}></GBtn>;
};

GBtnGradientBorderGlow.defaultProps = {
  fontColor: "#fff",
};

export default GBtnGradientBorderGlow;

/*

addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#21242C",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
})
*/
